<template>
  <app-content>
    <form action="#">
      <div class="inner">
        <app-content-title v-if="!newItem && !pending" :title="item.name" />
        <app-content-title v-if="newItem" :title="translations.newTvStation" />
      </div>
      <app-tabs
          :colsTabs="columnTabs"
          :shouldLoadFirstTab="newItem"
          :loadTab="params.tab"
          @appTabChanged="onAppTabChanged"
      >
      <div :title="translations.information">

      <app-settings @submit="submitForm" :disabled="pending">
        <app-settings-content>
          <app-settings-desc :title="translations.basicInfo">
            <p>
              <translate>Založeno</translate>:
              <br />
              <span v-html="formatDateAdvanced(item._created)" />
            </p>
            <p>
              <translate>Poslední změna</translate>:
              <br />
              <span v-html="formatDateAdvanced(item._updated)" />
            </p>
            <p>
              <translate>Počet kanálů</translate>
              : {{ item.numberOfChannels }}
            </p>

          <h2 v-translate>Poslední import</h2>
              <p>
                  <translate>Datum</translate>:
                  <br />
                  <span v-html="formatDateAdvanced(item._lastImport)" />
              </p>
          <p>
              <translate>Počet broadcastů</translate>
              : {{ item._lastImportBroadcastsCount }}
          </p>
          </app-settings-desc>

          <app-settings-options>
            <app-settings-col class="field_left">
              <app-input
                      required
                      :error="errors.items.find(el => el.field === 'name')"
                      :label="translations.name"
                      name="name"
                      v-model="formItem.name"
                  />
                </app-settings-col>

                <app-settings-col class="field_right">
                  <app-input
                      label="ID"
                      :error="errors.items.find(el => el.field === 'id')"
                      name="id"
                      v-model="formItem._id"
                      disabled
                  />
                </app-settings-col>

                <app-settings-col class="field_left">
                  <app-input
                      :label="translations.importId"
                      required
                      :error="errors.items.find(el => el.field === 'importId')"
                      name="importId"
                      v-model="formItem.importId"
                  />
                </app-settings-col>

                <app-settings-col class="field_right">
                  <app-settings-select
                      :error="errors.items.find(el => el.field === 'type')"
                      :label="translations.type"
                      required
                  >
                    <app-select
                        name="type"
                        :options="enums.tvStationType"
                        v-model="formItem.type"
                    />
                  </app-settings-select>
                </app-settings-col>

            <app-settings-col class="field_left">
              <app-settings-select
                  :error="errors.items.find(el => el.field === 'languageId')"
                  :label="translations.epgLanguage"
                  required
              >
                <app-select
                    name="languageId"
                    :options="languageSelect"
                    v-model="formItem.languageId"
                />
              </app-settings-select>
            </app-settings-col>

            <app-settings-col class="field_right">
              <app-input
                  :label="translations.importLanguage"
                  disabled
                  :error="errors.items.find(el => el.field === 'importedLanguage')"
                  name="importLanguage"
                  v-model="formItem.importLanguage"
              />
            </app-settings-col>

                <app-settings-col class="field_left">
              <app-input
                      :label="translations.version"
                      :error="errors.items.find(el => el.field === 'version')"
                      name="version"
                      v-model="formItem.version"
              />
                  <app-settings-select
                      :error="errors.items.find(el => el.field === 'countryId')"
                      :label="translations.tvStationCountry"
                  >
                    <app-select
                        name="countryId"
                        :options="countrySelect"
                        v-model="formItem.countryId"
                    />
                  </app-settings-select>
              <app-settings-control>
                <app-checkbox
                    name="broadcastsAssignable"
                    :title="translations.assigned"
                    v-model="formItem.broadcastsAssignable"
                />
              </app-settings-control>
                </app-settings-col>

                <app-settings-col class="field_right">
                  <app-settings-select
                      :error="errors.items.find(el => el.field === 'epgSourceId')"
                      :label="translations.epgSource"
                  >
                    <app-select
                        name="epgSourceId"
                        :options="epgSourceSelect"
                        v-model="formItem.epgSourceId"
                    />
                  </app-settings-select>

                  <app-settings-select
                      :error="errors.items.find(el => el.field === 'maturityRatingId')"
                      :label="translations.maturityRating"
                  >
                      <app-select
                          name="maturityRatingId"
                          :options="maturityRatingsSelect"
                          v-model="formItem.maturityRatingId"
                      />
                  </app-settings-select>
                </app-settings-col>

                <app-settings-col class="field_left">
                  <app-settings-select
                      required
                      :error="errors.items.find(el => el.field === 'streamingType')"
                      :label="translations.streamingType"
                  >
                    <app-select
                        selectId="streamingType"
                        :options="enums.tvStationStreamingType"
                        v-model="formItem.streamingType"
                        name="streamingType"
                    />
                  </app-settings-select>
                    <app-settings-control>
                        <app-checkbox
                            name="startLiveAsTimeshift"
                            :title="translations.startLiveAsTimeshift"
                            v-model="formItem.startLiveAsTimeshift"
                        />
                    </app-settings-control>
                </app-settings-col>

                <app-settings-col class="field_right">
              <app-settings-select
                  :error="errors.items.find(el => el.field === 'timezone')"
                  :label="translations.timezone"
              >
                <app-select
                    name="timezone"
                    :options="timezoneSelect"
                    v-model="formItem.timezone"
                />
              </app-settings-select>
              <app-settings-select
                  :error="errors.items.find(el => el.field === 'timezone')"
                  :label="translations.timezone"
              >
                <app-select
                    name="timezone"
                    :options="timezoneSelect"
                    v-model="formItem.timezone"
                />
              </app-settings-select>
              <app-settings-control>
                <app-checkbox
                    name="importImages"
                    :title="translations.importImages"
                    v-model="formItem.importImages"
                />
              </app-settings-control>
              <app-settings-control>
                <app-checkbox
                        name="hasParentLock"
                        :title="translations.parentalLock"
                        v-model="formItem.hasParentLock"
                    />
                  </app-settings-control>
                </app-settings-col>

                <app-settings-input
                    :error="errors.items.find(el => el.field === 'note')"
                    :label="translations.note">
                  <app-textarea
                      name="note"
                      v-model="formItem.note"
                  />
                </app-settings-input>
              </app-settings-options>
            </app-settings-content>

            <app-settings-content class="sync">
              <div class="left">
                <h2 v-translate>Skupiny</h2>
              </div>
              <div class="right checkbox_group">
                <ul v-if="stationGroupsChecked.length > 0">
                  <app-checkbox
                      v-for="group in stationGroupsChecked"
                      list
                      :title="group.name"
                      :key="group._id"
                      :form-value="group._id"
                      :checked="true"
                      name="tvStationGroupIds[]"
                  />
                </ul>
              </div>
              <div class="right checkbox_group">
                <ul>
                  <app-checkbox
                      v-for="group in stationGroupsNotChecked"
                      list
                      :title="group.name"
                      :key="group._id"
                      :form-value="group._id"
                      :checked="false"
                      name="tvStationGroupIds[]"
                  />
                </ul>

              </div>
            </app-settings-content>

        <app-settings-content class="sync">
          <div class="left">
            <h2 v-translate>Nastavení overlapů</h2>
          </div>

          <app-settings-options>
            <app-settings-col class="field_left">
              <app-input
                  type="number"
                  :error="errors.items.find(el => el.field === 'preOverlap')"
                  :label="translations.preOverlap"
                  name="preOverlap"
                  v-model="formItem.preOverlap"
              />
            </app-settings-col>

            <app-settings-col class="field_right">
              <app-input
                  type="number"
                  :label="translations.postOverlap"
                  :error="errors.items.find(el => el.field === 'postOverlap')"
                  name="postOverlap"
                  v-model="formItem.postOverlap"
              />
            </app-settings-col>
          </app-settings-options>
        </app-settings-content>

            <app-settings-content class="sync">
              <div class="left">
                <h2 v-translate>Kanály</h2>
              </div>
              <div class="right checkbox_group">
                <ul v-if="formItem.tvChannels">
                  <li v-for="channel in formItem.tvChannels" :key="channel._id">
                    <label>
                      <router-link :to="{ name: 'tv-channel', params: { id: channel._id}}">
                        {{ channel.name }}
                      </router-link>
                    </label>
                  </li>
                </ul>
                <div v-else v-translate>
                  Tato stanice neobsahuje žádné kanály
                </div>
              </div>
            </app-settings-content>

            <app-settings-buttons>
              <a
                  @click="$router.back()"
              >
                {{ translations.list }}
              </a>
              <app-content-save-button
                  @click="disallowBack"
              />
            </app-settings-buttons>
          </app-settings>
        </div>
        <div
            :title="translations.tvChannels + ' (' + item.numberOfChannels + ')'"
            :data-disabled-title="translations.tvChannels"
            :data-disabled="!item || !item._id"
        >
          <a
              class="tab_button tab_button_add"
              title="Přidat kanál"
              @click.prevent="createTvChannel"
          >Přidat kanál</a>

          <tv-channels
              :tv-station-id="item._id"
              :wrap-in-app-content="false"
          />
        </div>
      </app-tabs>
    </form>
  </app-content>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import ContentItem from 'components/AppContent'
import TvChannels from '../TvChannel/TvChannels'

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'TvStation',
  enums: true
})

export default {
  name: 'tv-station',
  components: {
    TvChannels,
    ContentItem
  },
  mixins: [formatDateMixin, itemDetailMixin, appTitleMixin()],
  created() {
    this.getTvStationGroupsOrderedByName()
    this.getLanguagesOrderedByName()
    this.getCountriesOrderedByName()
    this.getMaturityRatingsOrderedByName()
    this.getEpgSourcesOrderedByName()

    this.getTimezones()
    this.params.tab = 0
  },
  data() {
    return {
      tvStationGroupIds: [],
      columnTabs: [
        0,
        1
      ]
    }
  },
  computed: {
    ...mapState({
      stationGroups: state => state['tvStationGroups']['tvStationGroups'],
      epgSources: state => state['epgSources']['epgSources'],
      countries: state => state.countries.countries,
      languages: state => state.languages.languages,
      currentLanguage: state => state.uiLanguages.currentLanguage,
      timezones: state => state.tvStations.timezones,
      maturityRatings: state => state.maturityRatings.maturityRatings,
    }),
    translations() {
      return {
        newTvStation: this.$gettext('Nová TV stanice'),
        basicInfo: this.$gettext('Základní údaje'),
        name: this.$gettext('Název'),
        preOverlap: this.$gettext('Pre overlpap'),
        postOverlap: this.$gettext('Post overlpap'),
        importId: this.$gettext('Importní ID'),
        type: this.$gettext('Typ'),
        streamingType: this.$gettext('Typ vysílání'),
        version: this.$gettext('Verze'),
        epgLanguage: this.$gettext('Jazyk EPG'),
        importLanguage: this.$gettext('Importní jazyk'),
        tvStationCountry: this.$gettext('Stát TV stanice'),
        maturityRating: this.$gettext('Věková hranice'),
        epgSource: this.$gettext('Zdroj EPG'),
        timezone: this.$gettext('Časová zóna'),
        assigned: this.$gettext('Navazovat'),
        startLiveAsTimeshift: this.$gettext('Spouštět živě jako Timeshift'),
        importImages: this.$gettext('Importovat Obrázky'),
        active: this.$gettext('Aktivní'),
        note: this.$gettext('Poznámka'),
        list: this.$gettext('Seznam'),
        notSelected: this.$gettext('Nevybráno'),
        unknown: this.$gettext('Neurčeno'),
        information: this.$gettext('Informace'),
        tvChannels: this.$gettext('TV kanály'),
        parentalLock: this.$gettext('Rodičovský zámek')
      }
    },
    languageSelect() {
      return this.languages.map(v => ({ name: v.languageName, value: v._id }))
    },
    countrySelect() {
      return [{ name: this.translations.unknown, value: null }].concat(this.countries.map(v => ({ name: v.countryName, value: v._id })))
    },
    timezoneSelect() {
      return [{ name: 'Neurčeno', value: null }].concat(this.timezones.map(v => ({ name: v, value: v })))
    },
    groupSelect() {
      return this.stationGroups.map(v => ({ name: v.name, value: v._id }))
    },
    epgSourceSelect() {
      return [{ name: this.translations.notSelected, value: null }].concat(this.epgSources.map(v => ({ name: v.name, value: v._id })))
    },
    maturityRatingsSelect() {
        return [{ name: this.translations.notSelected, value: null }].concat(this.maturityRatings.map(v => ({ name: v.name, value: v._id })))
    },
    currentTitle() {
      return [
        { name: this.$gettext('TV stanice'), link: { name: 'tv-stations' } },
        this.item.name || this.$gettext('Nová TV Stanice')
      ]
    },
    stationGroupsChecked() {
      if (!this.pending) {
        return this.filterStationGroups(true)
      }
      return []
    },
    stationGroupsNotChecked() {
      if (!this.pending) {
        return this.filterStationGroups(false)
      }
      return []
    }
  },
  methods: {
    ...mapActions([
      'getTvStationGroups',
      'getEpgSources',
      'getLanguages',
      'getCountries',
      'getTimezones',
      'getMaturityRatings'
    ]),
    getTvStationGroupsOrderedByName() {
      this['getTvStationGroups']({
        params: {
          order: 'name'
        }
      })
    },
    getEpgSourcesOrderedByName() {
      this.getEpgSources({
        params: {
          order: 'name'
        }
      })
    },
    getLanguagesOrderedByName() {
      this.getLanguages({
        params: {
          idLanguage: localStorage.ui_language_id,
          order: 'languageNames'
        }
      })
    },
    getMaturityRatingsOrderedByName() {
        this.getMaturityRatings({
            params: {
                order: 'name'
            }
        });
    },
    getCountriesOrderedByName() {
      this.getCountries({
        params: {
          idLanguage: localStorage.ui_language_id,
          order: 'countryNames'
        }
      })
    },
    filterStationGroups(checked) {
      const arr = []
      if (!this.newItem) {
        Object.keys(this.stationGroups).forEach(v => {
          if (this.item.tvStationGroupIds.includes(this.stationGroups[v]._id) === checked) {
            arr.push(this.stationGroups[v])
          }
        })
      } else if (!checked) {
        return this.stationGroups
      }
      return arr
    },
    createTvChannel() {
      this.$router.push({
        name: 'tv-channel',
        params: {
          id: 'new'
        },
        query: {
          tvStationId: this.item._id,
          name: this.item.name
        }
      })
    }
  },
  watch: {
    currentLanguage() {
      this.getLanguagesOrderedByName()
      this.getCountriesOrderedByName()
    }
  }
}
</script>
